import { and, JsonSchema, schemaMatches, uiTypeIs } from '@jsonforms/core';

const findTextSchema = (schemas: JsonSchema[] = []) =>
  schemas.find(s => s.type === 'string' && s.enum === undefined);

const findEnumSchema = (schemas: JsonSchema[] = []) =>
  schemas.find(
    s => s.enum !== undefined && (s.type === 'string' || s.type === undefined)
  );

const hasEnumAndText = (schemas: JsonSchema[] = []) => {
  const enumSchema = findEnumSchema(schemas);
  const stringSchema = findTextSchema(schemas);
  const remainingSchemas = schemas.filter(
    s => s !== enumSchema || s !== stringSchema
  );
  const wrongType = remainingSchemas.find(s => s.type && s.type !== 'string');
  return !!(enumSchema && stringSchema && !wrongType);
};

export const simpleAnyOf = and(
  uiTypeIs('Control'),
  schemaMatches(
    schema =>
      Reflect.has(schema, 'anyOf') &&
      hasEnumAndText(schema.anyOf as JsonSchema[])
  )
);
